export const SERVICE_FEE_PERCENT = 14;

export const parseCommission = (value) => {
  const text = String(value).trim().replace(/^£\s*/, '');
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(text)) return null;
  const amount = Number(text.replace(/,/g, ''));
  return Number.isFinite(amount) && amount > 0 && amount <= 999999999.99 ? amount : null;
};

export const calculateCommissionBreakdown = (amount) => {
  const withdrawalPence = Math.round(amount * 100);
  // Integer arithmetic matches the backend's half-up penny rounding.
  const feePence = Math.floor((withdrawalPence * SERVICE_FEE_PERCENT + 50) / 100);
  return {
    withdrawalAmount: withdrawalPence / 100,
    serviceFee: feePence / 100,
    netAmount: (withdrawalPence - feePence) / 100,
  };
};

export const formatGBP = (amount) => new Intl.NumberFormat('en-GB', {
  style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2,
}).format(amount);